import { Controller } from '@hotwired/stimulus';
import { parse } from 'fecha';

const getDateTimeParts = (timestamp, timeZone) => Object.fromEntries(
    new Intl.DateTimeFormat('en', {
        day: '2-digit',
        hour: '2-digit',
        hourCycle: 'h23',
        minute: '2-digit',
        month: '2-digit',
        second: '2-digit',
        timeZone,
        year: 'numeric',
    })
        .formatToParts(new Date(timestamp))
        .map(part => [part.type, part.value])
);

const getTimeZoneOffset = (timestamp, timeZone) => {
    const parts = getDateTimeParts(timestamp, timeZone);

    return Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second) - timestamp;
};

const dateToTimestamp = (value, dateFormat, timeZone, endOfDay) => {
    const date = parse(value, dateFormat);

    if (!date) {
        return '';
    }

    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const boundary = Date.UTC(year, month - 1, day + (endOfDay ? 1 : 0));
    let timestamp = boundary;

    for (let i = 0; i < 3; i++) {
        const adjusted = boundary - getTimeZoneOffset(timestamp, timeZone);

        if (adjusted === timestamp) {
            break;
        }

        timestamp = adjusted;
    }

    return Math.floor(timestamp / 1000) - (endOfDay ? 1 : 0);
};

export default class extends Controller {
    static targets = ['value'];
    static values = {
        boundary: String,
        // Defaults to the input[type=date] value format (Y-m-d), see https://github.com/taylorhakes/fecha#formatting-tokens
        format: { type: String, default: 'YYYY-MM-DD' },
        timeZone: String,
    };

    update(event) {
        if (event.currentTarget.value) {
            this.valueTarget.value = dateToTimestamp(event.currentTarget.value, this.formatValue, this.timeZoneValue, this.boundaryValue === 'end');
        } else {
            this.valueTarget.value = '';
        }
    }
}
